import K from '../constants';
import restHelpers from '../helpers/restHelper';
import authStore from '../stores/authStore';

const token = () => restHelpers.withBasic('sellerwebapp', 'z5wmY8NM').post(`${K.AIRWEB_API_URL}/authorize/cognito-token`, { data: { cognitoToken: authStore.token } });

export default {
  token
};
